export default __webpack_public_path__ + "static/agro-meta-2a9c4535b95d8105d5524e3281bbf921.png";